import { motion } from 'framer-motion'
import { FaWhatsapp } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { BOOK_DEMO_PATH } from '@/lib/cta'
import { trackBookDemoClick } from '@/lib/openaiAds'

const WHATSAPP_URL =
  'https://wa.me/96170510509?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20Statbox.'

// Closing CTA — one big typographic promise, one dominant action.
// Follows the Linear/Stripe pattern: no boxes, no icon tiles, just
// disciplined type and a single clear next step.
export const ClosingCTA = () => {
  return (
    <section
      id="contact"
      className="relative overflow-hidden bg-black py-24 sm:py-32"
    >
      {/* Quiet ambient glow, consistent with the hero */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 60% 50% at 50% 100%, rgba(113,205,217,0.14) 0%, transparent 70%)',
        }}
      />

      <div className="relative mx-auto w-full max-w-[880px] px-5 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="text-[2.2rem] sm:text-5xl lg:text-[3.6rem] font-extrabold tracking-tight leading-[1.08] text-white text-balance">
            See it on a real game.
          </h2>
          <p className="mx-auto mt-5 max-w-md text-base sm:text-lg text-white/70 leading-relaxed">
            Thirty minutes. You pick the time.
          </p>

          <div className="mt-10 flex flex-col items-center gap-4">
            <Link
              to={BOOK_DEMO_PATH}
              onClick={trackBookDemoClick}
              className="inline-flex min-h-[64px] w-full max-w-[420px] items-center justify-center rounded-full px-8 text-[1.125rem] font-bold tracking-[-0.02em] text-[#071018] shadow-[0_18px_40px_-12px_rgba(113,205,217,0.7),inset_0_1px_0_rgba(255,255,255,0.45)] transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#8fe0ec] focus-visible:ring-offset-2 focus-visible:ring-offset-black motion-reduce:transition-none motion-reduce:hover:scale-100"
              style={{ background: 'linear-gradient(180deg, #8fe0ec 0%, #71cdd9 58%, #5dbac6 100%)' }}
            >
              Book a meeting
            </Link>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[44px] items-center gap-2 text-[14px] text-white/50 hover:text-white transition-colors"
            >
              <FaWhatsapp className="h-4 w-4 text-[#25D366]" aria-hidden />
              Prefer WhatsApp? Say hi
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
